import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplyLeave, CancelLeave, ChangeLeaveStatus, HttpResponse, LeaveDetail, LeaveOverview, LeaveRequestDetail, WfhRequests, WfhRequestDetail } from "../public-api";
import { CommonWebService } from "./commonweb.service";
import { UserHttpService } from "./user-session.service";

@Injectable({
    providedIn: "root",
})
export class LeaveManagementService {
    constructor(
        private userSessionService: UserHttpService,
        private commonService: CommonWebService,
        private http: HttpClient
    ) { }

    applyLeave(body: ApplyLeave, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("leave_type", body.leave_type ? body.leave_type : "");
        formData.append("leave_purpose", body.leave_purpose ? body.leave_purpose : "");
        formData.append("from_date", body.from_date ? this.commonService.changeDateFormat(new Date(body.from_date)) : "");
        formData.append("leave_description", body.leave_description ? body.leave_description : "");
        if (body.document) {
            formData.append('file', body.document ? body.document : '');
        }

        if (body.leave_type == '2' || body.leave_type == '3') {
            formData.append("start_time", body.start_time ? body.start_time : "");
            formData.append("end_time", body.end_time ? body.end_time : "");
        } else {
            formData.append("to_date", body.to_date ? this.commonService.changeDateFormat(new Date(body.to_date)) : "");
        };

        if (body.leave_purpose == 'Other') {
            formData.append("leave_purpose_other", body.leave_purpose_other ? body.leave_purpose_other : "");
        }

        if (isEdit && body.leave_id) {
            formData.append("leave_id", body.leave_id ? body.leave_id : "");
        }
        return this.http.post<HttpResponse<any>>("leaves/applyLeave", formData);
    }

    //get list of my leaves
    getMyLeaves(
        keyword_search?: string,
        from_date?: Date,
        to_date?: Date,
        leave_type?: string,
        leave_frequency?: string,
        limit?: number,
        offset?: number
    ): Observable<HttpResponse<LeaveDetail[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);

        if (keyword_search) {
            formData.append("keyword_search", keyword_search ? keyword_search : '');
        }
        if (from_date) {
            formData.append("from_date", from_date ? this.commonService.changeDateFormat(from_date) : '');
        }
        if (to_date) {
            formData.append("to_date", to_date ? this.commonService.changeDateFormat(to_date) : '');
        }
        if (leave_type) {
            formData.append("leave_type", leave_type ? leave_type : '');
        }
        if (leave_frequency) {
            formData.append("leave_frequency", leave_frequency ? leave_frequency : '')
        }
        if (limit !== undefined) {
            formData.append('limit', limit.toString());
        }
        if (offset !== undefined) {
            formData.append('offset', offset.toString());
        }

        return this.http.post<HttpResponse<LeaveDetail[]>>('leaves/myleaves', formData);
    }

    //get leaves overview
    getLeavesOverview(leaveYear: string, leavemonth: string, emp_id: string): Observable<any> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("leaveYear", leaveYear);
        formData.append("leavemonth", leavemonth);
        formData.append("emp_id", emp_id);
        return this.http.post<HttpResponse<LeaveOverview[]>>('leaves/UsersLeaveOverview', formData);
    }

    //get list of leave request for approve permission user
    getLeaveRequests(
        keyword_search?: string,
        from_date?: Date,
        to_date?: Date,
        leave_type?: string,
        leave_frequency?: string,
        offset?: number,
        limit?: number,
    ): Observable<HttpResponse<LeaveRequestDetail[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        if (keyword_search) {
            formData.append("keyword_search", keyword_search ? keyword_search : '');
        }
        if (from_date) {
            formData.append("from_date", from_date ? this.commonService.changeDateFormat(from_date) : '');
        }

        if (to_date) {
            formData.append("to_date", to_date ? this.commonService.changeDateFormat(to_date) : '');
        }

        if (leave_type) {
            formData.append("leave_type", leave_type ? leave_type : '');
        }
        if (leave_frequency) {
            formData.append("leave_frequency", leave_frequency ? leave_frequency : '');
        }
        if (limit !== undefined) {
            formData.append('limit', limit.toString());
        }
        if (offset !== undefined) {
            formData.append('offset', offset.toString());
        }

        return this.http.post<HttpResponse<LeaveRequestDetail[]>>('leaves/leaveRequest', formData);
    }

    //get leave detail
    getLeaveDetail(id: string): Observable<HttpResponse<LeaveDetail[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("leave_id", id ? id : "");
        return this.http.post<HttpResponse<LeaveDetail[]>>('leaves/leaveRequestDetail', formData);
    }

    //accept /decline / reject
    changeLeaveStatus(body: ChangeLeaveStatus): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("leave_id", body.leave_id ? body.leave_id : "");
        formData.append("comments", body.comments ? body.comments : "");
        formData.append("leave_status", body.leave_status ? body.leave_status : "");
        return this.http.post<HttpResponse<any>>('leaves/leaveAcceptDecline', formData);
    }

    //accept /decline
    cancelLeave(body: CancelLeave): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("leave_id", body.leave_id ? body.leave_id : "");
        formData.append("leave_start_date", body.leave_start_date ? `${body.leave_start_date}` : "");
        return this.http.post<HttpResponse<any>>('leaves/cancelLeave', formData);
    }

    //get leave types
    getAllLeaveTypes(): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        return this.http.post<HttpResponse<any>>('leaves/LeaveTypeList', formData);
    }


    /*--Public holidays list--*/
    //get leaves overview
    getListOfPublicHolidays(holidayYear: string): Observable<any> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("holiday_year", holidayYear);
        return this.http.post<HttpResponse<LeaveOverview[]>>('leaves/holidaysList', formData);
    }

    /*--Leave OverView Detailed--*/
    getUserSpecificLeaveOverview(emp_id: string, leaveYear: string): Observable<any> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("emp_id", emp_id);
        formData.append("leaveYear", leaveYear);
        return this.http.post<HttpResponse<LeaveOverview[]>>('leaves/leaveOverviewByUser', formData);
    }
}
